export default "__VITE_ASSET__DPur8toe__"